import React, { useState } from 'react';
import { DreamInput } from './components/DreamInput';
import { DreamCard, Dream } from './components/DreamCard';
import { DreamDetail } from './components/DreamDetail';
const SAMPLE_DREAMS: Dream[] = [{
  id: '1',
  content: "The fear that I made the wrong choice leaving my job last month. Everyone keeps saying it was brave. I just feel like I'm floating with nothing to hold onto. I keep refreshing my email like something will arrive and tell me it's going to be okay.",
  date: 'Mar 3, 2026',
  rotation: -2
}, {
  id: '2',
  content: "My mom called yesterday and she sounded older than I remembered. I don't know when that happened. I live three time zones away and I keep telling myself I'll visit soon, but soon keeps moving further out like a horizon.",
  date: 'Mar 3, 2026',
  rotation: 1.5
}, {
  id: '3',
  content: "A quiet, stubborn hope that things can still get better. Not in a naive way. I've seen enough to know it's hard. But I woke up this morning and the light was coming through the window at a good angle and I thought — maybe. Just maybe.",
  date: 'Mar 3, 2026',
  rotation: -1
}];
export function App() {
  const [dreams, setDreams] = useState<Dream[]>(SAMPLE_DREAMS);
  const [selectedDream, setSelectedDream] = useState<Dream | null>(null);
  const handleAddDream = (text: string) => {
    const newDream: Dream = {
      id: Date.now().toString(),
      content: text,
      date: new Date().toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }),
      rotation: Math.random() * 6 - 3
    };
    setDreams([newDream, ...dreams]);
  };
  return <div className="min-h-screen w-full pb-20 px-4 md:px-8" data-id="element-0">
      <header className="pt-16 pb-12 text-center" data-id="element-1">
        <h1 className="font-serif text-5xl md:text-6xl text-[#5c4033] mb-4 tracking-wide" data-id="element-2">
          What We're Carrying
        </h1>
        <p className="font-serif text-xl italic text-[#8b7355]" data-id="element-3">
          This is a place to share something you're quietly carrying right now.
        </p>
      </header>

      <main className="max-w-7xl mx-auto" data-id="element-4">
        <DreamInput onSubmit={handleAddDream} data-id="element-5" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 mt-16 px-2" data-id="element-6">
          {dreams.map(dream => <DreamCard key={dream.id} dream={dream} onClick={setSelectedDream} data-id="element-7" />)}
        </div>
      </main>

      {selectedDream && <DreamDetail dream={selectedDream} onClose={() => setSelectedDream(null)} data-id="element-8" />}

      <footer className="mt-24 text-center font-serif text-[#8b7355] italic opacity-60 pb-8" data-id="element-9">
        <p className="text-[24px] font-[800]" data-id="element-10">You are loved.</p>
      </footer>
    </div>;
}